import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { ModalContainer } from '../../components/layout'
import { RevolvingDotSpinner } from '../../components/Spinner'
import { companySwitcherMessages } from './messages'

const Content = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  padding: 0 1.5rem;
  text-align: center;
`

const SwitchingText = styled.p`
  margin: 0;
  padding: 0;
  color: ${props => props.theme.colors.black};
  font-size: 1.5em;
  line-height: 2rem;
  word-break: break-word;
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    font-size: 1.1rem;
    line-height: 1.5rem;
  }
`

interface Props {
  companyName: string
}

export const CompanySwitchingModal: React.FunctionComponent<Props> = ({ companyName }) => {
  const intl = useIntl()

  return (
    <ModalContainer>
      <Content>
        <RevolvingDotSpinner visible color="#fabf40" height={100} width={100} />
        <SwitchingText>
          {intl.formatMessage(companySwitcherMessages.switching_message, { companyName })}
        </SwitchingText>
      </Content>
    </ModalContainer>
  )
}
